import * as React from 'react';
import { useSelector } from 'react-redux';
import {
	getAggregatorInsurancesByGroups
} from '../../../store/order/selectors';
import { getDisplayInsurancesByGroups } from '../../../store/order/selectors';
import InsuranceUpsale from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsale';
import InsuranceUpsaleAggregator from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleAggregator';
import InsuranceV2 from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleV2';

interface Props {
	aggregatorMode?: boolean;
	cardV2Style?: boolean;
	segmentId?: string;
	hideCard?: boolean;
}

const OrderInsuranceBlockSlotUpsale: React.FC<Props> = ({
	aggregatorMode = false,
	cardV2Style,
	segmentId,
	hideCard
}) => {
	const canBeAddedInsurancesByGroups = useSelector(getDisplayInsurancesByGroups);
	const aggregatorInsurancesByGroups = useSelector(getAggregatorInsurancesByGroups);
	const insurancesByGroups = aggregatorMode ? aggregatorInsurancesByGroups : canBeAddedInsurancesByGroups;

	if (aggregatorMode && !cardV2Style) {
		return (
			<>
				{insurancesByGroups.map((insurances, index) => (
					<InsuranceUpsaleAggregator
						key={index}
						groupName={insurances.groupName}
						insurancePrograms={insurances.insurancePrograms}
						oldVersion={true}
						segmentId={segmentId}
						hideCard={hideCard}
					/>
				))}
			</>
		);
	}

	let Insurance = InsuranceUpsale;

	if (cardV2Style) {
		Insurance = InsuranceV2;
	}

	return (
		<>
			{insurancesByGroups.map((insurances, index) => (
				<Insurance
					key={index}
					groupName={insurances.groupName}
					insurancePrograms={insurances.insurancePrograms}
					oldVersion={true}
					segmentId={segmentId}
				/>
			))}
		</>
	);
};

export default OrderInsuranceBlockSlotUpsale;
